import { render, staticRenderFns } from "./MailableAttachment.vue?vue&type=template&id=b37437fe&"
import script from "./MailableAttachment.vue?vue&type=script&lang=js&"
export * from "./MailableAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports